import { isElementNode, isTextNode } from 'anodum';
import { constants } from '../../utils/classes/mutation-driver';

const MUTATION_ATTRIBUTE = 'data-ws-mutation';
const IGNORE_ATTRIBUTE = 'data-ws-ignore';

const shouldIgnoreNode = (node) => isElementNode(node) && node.hasAttribute(IGNORE_ATTRIBUTE);

const remove = (node) => {
  if (isElementNode(node)) {
    node.removeAttribute(MUTATION_ATTRIBUTE);

    if (shouldIgnoreNode(node)) {
      node.removeAttribute(IGNORE_ATTRIBUTE);
    }
  }
};

const shouldPreserveNode = (node) => isElementNode(node) && node.hasAttribute(MUTATION_ATTRIBUTE);

const preserve = (node) => {
  if (isElementNode(node)) {
    node.setAttribute(MUTATION_ATTRIBUTE, true);
  }

  if (isTextNode(node)) {
    const comment = document.createComment(constants.STATIC_TEXT_TOKEN);

    node.parentNode.insertBefore(comment, node);
  }
};

const ignore = (node, withSubtree = false) => {
  if (isElementNode(node)) {
    node.setAttribute(IGNORE_ATTRIBUTE, true);

    if (withSubtree) {
      node.childNodes.forEach((childNode) => ignore(childNode, withSubtree));
    }
  }

  if (isTextNode(node) && node.parentNode.firstChild.nodeValue === constants.STATIC_TEXT_TOKEN) {
    node.parentNode.firstChild.remove();
  }
};

export default {
  preserve,
  remove,
  shouldPreserveNode,
  shouldIgnoreNode,
  ignore,
};
